<template>
  <div
    v-if="shouldShowButton || serverError !== null"
    class="d-flex flex-column gap-4 px-4 py-2"
  >
    <VisitorErrorHandler
      v-if="serverError"
      :error="serverError"
      @done="serverError = null"
    />
    <div class="button-info-box-container">
      <InfoBox
        title="Enable Browser Notifications for Student Appointment Requests"
        class="info-box"
      >
        <p class="text-muted mb-0">
          The system requires you to enable this setting to receive browser push
          notifications for student appointment requests and appointment
          reminders.
        </p>
      </InfoBox>
      <LoadingButton
        v-if="shouldShowButton"
        rounded
        @click="enableBrowserNotification"
        data-testid="enable-browser-notification-button"
      >
        Enable Browser Notification
      </LoadingButton>
    </div>
  </div>
</template>

<script>
import useFcmToken from "@/composables/useFcmToken"
import visitorUtils from "@/helpers/visitorUtils"
import InfoBox from "@/v3components/shared/Alerts/InfoBox.vue"
import LoadingButton from "@/v3components/shared/Buttons/LoadingButton.vue"
import VisitorErrorHandler from "@/v3components/VisitorErrorHandler.vue"
import { computed, onMounted, ref } from "vue"
import { useStore } from "vuex"

export default {
  name: "BrowserNotificationButton",
  components: {
    LoadingButton,
    VisitorErrorHandler,
    InfoBox
  },
  setup() {
    const store = useStore()
    const serverError = ref(null)
    const { initializeFcmToken } = useFcmToken()

    const user = computed(() => {
      return store.getters["authentication/user"]
    })

    const isBrowserNotificationEnabledFromStore = computed(() => {
      return (
        store?.getters?.["visitorSettings/isBrowserNotificationEnabled"] ||
        false
      )
    })

    const shouldShowButton = computed(() => {
      return (
        !isBrowserNotificationEnabledFromStore.value &&
        !visitorUtils.forSettings.isBrowserNotificationEnabled()
      )
    })

    onMounted(async () => {
      try {
        if (!user.value?.id) return

        await initializeFcmToken(user.value.id)
      } catch (error) {
        serverError.value = error
      }
    })

    const enableBrowserNotification = async () => {
      try {
        await visitorUtils.forSettings.enableBrowserNotification()
      } catch (error) {
        serverError.value = error
      }
    }

    return {
      shouldShowButton,
      serverError,
      enableBrowserNotification
    }
  }
}
</script>

<style scoped>
.button-info-box-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
}

.info-box {
  flex: 1;
}
</style>
